<template>
  <div id="content">
    <core-app-view />

    <v-row>
      <v-col cols="12">
        <v-sheet class="mx-auto" dark color="#263238" height="250">
          <v-row
            style="padding-top: 100px"
            class="fill-height"
            align="center"
            align-content="center"
            justify="center"
          >
            <v-col cols="12" class="text-center">
              <h5 class="display-1 font-weight-thin">{{ datafile.title }}</h5>
              <h3 class="font-weight-bold">{{ datafile.subtitle }}</h3>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-card flat class="mx-auto align-center pa-4" style="margin-top: 30px">
        <v-row
          style="padding-left: 150px; padding-right: 150px"
          align="center"
          justify="center"
        >
          <v-col class="text-start" cols="12">
            <v-row class="fill-height" align="center" justify="start">
              <v-col class="text-start" cols="8">
                <h2 class="display-1 font-weight-bold">
                  암모나이트를 만나다
                </h2>
              </v-col>
              <v-col style="padding-top: 10vh">
                <v-btn plain large color="primary">
                  <v-icon small>{{ icons.mdiEmailSendOutline }}</v-icon>
                  <a :href="link1">
                    <h3 style="margin-left: 5px;">Request</h3>
                  </a>
                </v-btn>
              </v-col>
              <v-divider light vertical inset />
              <v-col cols="8"> </v-col>
              <v-col cols="3" />
              <v-col cols="12">
                <div v-html="datafile.about.split('\n').join('<br />')"></div>
              </v-col>
              <v-col cols="12">
                <body>
                  <a :href="datafile.paperlink">
                    논문 링크
                  </a>
                </body>
                <v-col class="text-start" cols="12" style="margin-top: 5vh;">
                  <h2 class="display-1 font-weight-light">
                    Demo
                  </h2>
                </v-col>
                <video class="left" controls width="60%">
                  <source
                    src="@/assets/ammonite/암모나이트를 만나다.mp4"
                    type="video/mp4"
                  />
                  Sorry, your browser doesn't support embedded videos.
                </video>
              </v-col>
            </v-row>

            <v-row class="fill-height" align="center" justify="start">
              <v-col class="text-start" cols="12" style="margin-top: 15vh;">
                <h1 class="display-1 font-weight-bold">
                  암모나이트를 만나다 (AR + Holographic Display)
                </h1>
              </v-col>
              <v-divider light vertical inset />
              <v-col cols="12">
                <body>
                  <div v-html="datafile.arhd.split('\n').join('<br />')"></div>
                </body>
              </v-col>
              <v-col class="text-start" cols="12" style="margin-top: 5vh;">
                <h2 class="display-1 font-weight-light">
                  Demo
                </h2>
              </v-col>
              <video
                class="left"
                controls
                width="60%"
                style="margin-bottom: 10vh;"
              >
                <source
                  src="@/assets/ammonite/암모나이트를 만나다 Demo.mp4"
                  type="video/mp4"
                />

                Sorry, your browser doesn't support embedded videos.
              </video>
            </v-row>

            <v-row class="fill-height" align="center" justify="start">
              <v-col class="text-start" cols="12" style="margin-top: 15vh;">
                <h1 class="display-1 font-weight-bold">
                  암모나이트를 만나다 (VR)
                </h1>
              </v-col>
              <v-divider light vertical inset />
              <v-col cols="12">
                <body>
                  <div v-html="datafile.vr.split('\n').join('<br />')"></div>
                </body>
              </v-col>
              <v-col class="text-start" cols="12" style="margin-top: 5vh;">
                <h2 class="display-1 font-weight-light">
                  Demo
                </h2>
              </v-col>
              <video
                class="left"
                controls
                width="60%"
                style="margin-bottom: 10vh;"
              >
                <source src="@/assets/ammonite/VR_demo.mp4" type="video/mp4" />

                Sorry, your browser doesn't support embedded videos.
              </video>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import { mdiEmailSendOutline, mdiArrowUp } from "@mdi/js";

export default {
  name: "ContentComponent",
  data: () => ({
    icons: {
      mdiEmailSendOutline,
      mdiArrowUp,
    },
    link1: "https://forms.gle/R2m661HLwxYQeLta9",
    publicPath: process.env.BASE_URL,
    imgPath: "../assets/sketchscope.png",
  }),
  props: {
    datafile: Object,
  },

  components: {
    CoreAppView: () => import("@/components/core/AppView"),
  },
};
</script>
